import { RootState } from '@/store/store';
import { createSelector } from '@reduxjs/toolkit';
import { addDomainFormTypes } from '@/store/types/addDomainFormTypes';

export const selectWidgetNewDomainState = (state: RootState): addDomainFormTypes => state.widgetNewDomain.data;

export const selectWidgetNewDomainError = (state: RootState): string | null => state.widgetNewDomain.error;

export const selectInitialDomainState = createSelector(
	[selectWidgetNewDomainState],
	(newDomainState) => newDomainState
);

export const selectDomainFormError = createSelector(
	[selectWidgetNewDomainError],
	(error) => error
);
